const BackIcon = () => (
  <svg
    width='16px'
    height='16px'
    viewBox='0 0 16 16'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>back</title>
    <g
      id='back'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <path
        d='M7.64006785,2.63947108 L9.02462302,4.08273369 L5.77583929,7.19947108 L15,7.2 L15,9.2 L5.72183929,9.19947108 L9.05340377,12.668228 L7.6112871,14.0539767 L1.91783929,8.12893718 L7.64006785,2.63947108 Z'
        id='Combined-Shape'
        fill='#8400FF'
        fillRule='nonzero'
      />
    </g>
  </svg>
)

export default BackIcon
